export default __webpack_public_path__ + "static/media/map.b97b2502.svg";